(function (w, d) {
	const throttleTime = 200;
	w.addEventListener('scroll', throttle(setBottomOffset, throttleTime));
	if (!w.zE) {
		zendeskChatBottomOffset('init');
	}

	function setBottomOffset() {
		if (!w.zE) {
			zendeskChatBottomOffset('init');
		} else {
			zendeskChatBottomOffset();
		}
	}

	function zendeskChatBottomOffset(zEStatus = 'false') {
		const offset = w.innerWidth < 768 ? 70 : 0;
		const offsetBottom = w.calcBottomOffset(offset);

		const settings = {
			webWidget: {
				zIndex: 2,
				offset: {
					vertical: `${offsetBottom}px`,
					mobile: {
						vertical: `${offsetBottom}px`,
					}
				}
			}
		};

		if (zEStatus === 'init') {
			w.zESettings = {...settings};
		} else {
			w.zE('webWidget', 'updateSettings', {...settings});
		}
	}
})(window, document);
